import React from 'react';
import { NavLink } from 'react-router-dom';
import imageLogoType from '../assets/images/logo-type.svg';
import { useAppSelector } from '../app/store/hooks';
import {
  defaultRoutesByRole,
  paths,
  roles,
} from '../app/routes/paths';
import { useAppRole } from '../app/routes/useRolePath';

const Brand = () => {
  const accessToken = useAppSelector(
    (state) => state.authorization.accessToken,
  );
  const role = useAppRole();
  const isAuthenticated = Boolean(accessToken) && role !== roles.NONE;
  const to = isAuthenticated ? defaultRoutesByRole[role] : paths.home;

  return (
    <div className="brand-block">
      <NavLink to={to} className="nav__logo" end>
        <img src={imageLogoType} alt="" />
      </NavLink>
    </div>
  );
};

export default Brand;
